import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TelemonitoringHttpService } from '@services/http/telemonitoring.http.service';
import { selectTelemonitoringClientCode } from '@shared/store/telemonitorings/telemonitorings.selectors';
import { catchError, map, of, switchMap, take } from 'rxjs';

export const telemonitoringClientCodeGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const store = inject(Store);
  const router = inject(Router);
  const telemonitoringHttpService = inject(TelemonitoringHttpService);

  const routeClientCode = route.params.clientCode;
  const telemonitoringId = Number(route.paramMap.get('tmId'));

  return store.select(selectTelemonitoringClientCode(telemonitoringId)).pipe(
    take(1),
    switchMap((storedClientCode) =>
      storedClientCode
        ? of(storedClientCode)
        : telemonitoringHttpService
            .getTelemonitoring(telemonitoringId)
            .pipe(map((telemonitoring) => telemonitoring.clientCode)),
    ),
    map((clientCode) => {
      if (!clientCode) {
        return router.createUrlTree(['/telemonitorings']);
      }
      return clientCode === routeClientCode
        ? true
        : router.createUrlTree(['/client', clientCode, 'telemonitorings', telemonitoringId]);
    }),
    catchError(() => of(router.createUrlTree(['/telemonitorings']))),
  );
};
